import { Outlet } from "react-router-dom";
import { BottomNav } from "./BottomNav";
import "./Layout.css";

export function Layout() {
  return (
    <div className="layout">
      <header className="header">
        <div className="header-content">
          <h1 className="logo">Forge</h1>
        </div>
      </header>
      <main className="main-content">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
